import { Component, OnInit } from '@angular/core';
import { HomeBaseComponent } from '../../../common/base-controllers/home-base.component';
import { SeasonTicketsService } from '../../../common/services/season-tickets.service';
import { Event } from '../../../common/types/event';
import { Router } from '@angular/router';
import { LoaderService } from '../../../common/services/loader.service';
import { SubscriptionService } from '../../../common/services/subscription.service';
import { DynamicPopupService } from '../../../common/services/dynamic-popup.service';

@Component({
  selector: 'app-home-desktop',
  templateUrl: './home-desktop.component.html',
  styleUrls: ['./home-desktop.component.scss'],
})
export class HomeDesktopComponent extends HomeBaseComponent {
  public translate = 'translate3d(0, 0, 0)';
  public currentSliderIndex = 0;

  constructor(
    seasonTicketsService: SeasonTicketsService,
    loaderService: LoaderService,
    subscriptionService: SubscriptionService,
    dynamicPopup: DynamicPopupService,
    private router: Router
  ) {
    super(
      seasonTicketsService,
      loaderService,
      subscriptionService,
      dynamicPopup
    );
  }

  public slide(step: number): void {
    const itemsCount = this.topEvents.length;
    this.currentSliderIndex = Math.max(
      Math.min(this.currentSliderIndex + step, Math.ceil(itemsCount / 3) - 1),
      0
    );
    const leftoverItemsPagePercent =
      Math.ceil(itemsCount / 3) - 1 === this.currentSliderIndex &&
      itemsCount % 3 !== 0
        ? 100 - (itemsCount % 3) * 33.33
        : 0;
    this.translate = `translate3d(${
      this.currentSliderIndex * -100 + leftoverItemsPagePercent
    }%, 0, 0)`;
  }

  public dotClickHandler(dotIndex: number) {
    const step = dotIndex - this.currentSliderIndex;
    this.slide(step);
  }

  public navigateToTicketSchedule(event: Event): void {
    this.router.navigate(['/schedule'], {
      queryParams: { eventId: event.id },
    });
  }
}
